import { DATE_FORMAT_YYYYMMDD } from "@app/constants";
import { StatisticsType } from "@app/constants/statistics.const";
import { ChartConfig, StatisticsState } from "@app/types";
import dayjs from "dayjs";

export const initialStateStatistics = Object.freeze<StatisticsState>({
  typeChart: StatisticsType[0],
  typeUser: { label: "ALL", value: "ALL" },
  voucherCode: "",
  filterDate: "allTime",
  startDate: undefined,
  endDate: undefined,
  startDateTemp: undefined,
  endDateTemp: undefined,
  userType: [],
  userTypeTemp: [],
  bookIds: [],
  dataVoucherActiveInteraction: [],
  totalListener: 0,
});

export const initialVoucherChartConfig: ChartConfig = {
  type: "bar",
  data: {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: "#5570F1",
        borderColor: "#5570F1",
        borderWidth: 1,
        borderRadius: 8,
      },
    ],
  },
};

export const calculateDateTemp = (
  value: string,
  startDate?: string,
  endDate?: string
) => {
  let startDateTemp = startDate;
  let endDateTemp = endDate;

  switch (value) {
    case "thisWeek":
      startDateTemp = dayjs().startOf("week").format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs().endOf("week").format(DATE_FORMAT_YYYYMMDD);
      break;
    case "lastWeek":
      startDateTemp = dayjs()
        .subtract(1, "week")
        .startOf("week")
        .format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs()
        .subtract(1, "week")
        .endOf("week")
        .format(DATE_FORMAT_YYYYMMDD);
      break;
    case "thisMonth":
      startDateTemp = dayjs().startOf("month").format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs().endOf("month").format(DATE_FORMAT_YYYYMMDD);
      break;
    case "lastMonth":
      startDateTemp = dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format(DATE_FORMAT_YYYYMMDD);
      break;
    case "thisYear":
      startDateTemp = dayjs().startOf("year").format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs().endOf("year").format(DATE_FORMAT_YYYYMMDD);
      break;
    case "lastYear":
      startDateTemp = dayjs()
        .subtract(1, "year")
        .startOf("year")
        .format(DATE_FORMAT_YYYYMMDD);
      endDateTemp = dayjs()
        .subtract(1, "year")
        .endOf("year")
        .format(DATE_FORMAT_YYYYMMDD);
      break;
    case "allTime":
      startDateTemp = undefined;
      endDateTemp = undefined;
      break;
  }

  return { startDateTemp, endDateTemp };
};

export const generateVoucherChartConfig = ({
  text,
  labels,
  data,
}: {
  text: string | string[];
  labels: string[];
  data: number[];
}): ChartConfig => {
  return {
    type: "bar",
    data: {
      labels,
      datasets: [
        {
          data,
          backgroundColor: "#5570F1",
          borderColor: "#5570F1",
          borderWidth: 1,
          borderRadius: 8,
        },
      ],
    },
    options: {
      responsive: true,
      plugins: {
        title: {
          display: true,
          text,
          position: "bottom",
          font: {
            size: 16,
            weight: "normal",
          },
        },
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          mode: "index",
          intersect: false,
          callbacks: {
            title: (tooltipItems) => {
              return `Ngày: ${tooltipItems[0].label}`;
            },
            label: (tooltipItem) => {
              return `Số user: ${tooltipItem.raw}`;
            },
          },
          backgroundColor: "rgba(0,0,0,0.7)",
          titleColor: "#fff",
          bodyColor: "#fff",
          borderColor: "rgba(255, 255, 255, 0.3)",
          borderWidth: 1,
          displayColors: false,
        },
      },
    },
  };
};
